export class ModalLoadError extends Error {
  readonly modalType: string;

  readonly originalError: unknown;

  constructor(modalType: string, originalError: unknown) {
    super(`Modal type "${modalType}" failed to load.`);

    this.name = 'ModalLoadError';
    this.modalType = modalType;
    this.originalError = originalError;
  }
}
